import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-tqw-filter-dropdown',
    templateUrl: './tqw-filter-dropdown.component.html',
    styleUrls: ['./tqw-filter-dropdown.component.scss']
})
export class TqwFilterDropdownComponent implements OnInit, OnChanges {
    @Input() column;
    @Input() list: any[];
    @Input() filterKey: string;
    @Input() resetFilter;
    @Output() OnSelectFilter: EventEmitter<any> = new EventEmitter<any>();

    filteredByList = [];
    allTextAsString = 'all';
    filteredByAsString = this.allTextAsString;
    allOptionDisabled = false;
    showLoader = true;
    statusId!: string;

    constructor(private translateService: TranslateService) {}

    ngOnInit(): void {
        this.allOptionDisabled = true;
        console.log('list',this.list,this.filterKey,this.column);
    }
    onChange(e, item) {
        item.checked = e.checked;
        this.handleSelectedFilterOptions(e, item);
        this.handleAllOption(item);
        //if nothing is selected, then set 'All' by default
        this.setAllOptionWhenNoOptionIsSelected();
    }

    handleSelectedFilterOptions(event, item) {
        if (event.checked) {
            this.filteredByList.push(item);
        } else {
            const index = this.filteredByList.findIndex(v => v.id === item.id);
            this.filteredByList.splice(index, 1);
        }
    }

    handleFilteredByDisplayName() {
        if (this.filteredByList.length === 1) {
            const name = this.filteredByList[0].name.length > 20 ? this.filteredByList[0].name.substr(0, 20) + '...' : this.filteredByList[0].name;
            this.filteredByAsString = name;
        } else if (this.filteredByList.length > 1) {
            this.filteredByList.map((element, i) => {
                if (i === 0) {
                    const name = element.name.length > 20 ? element.name.substr(0, 20) + '...' : element.name;
                    this.filteredByAsString = name + '، ...';
                }
            });
        }
    }

    handleAllOption(item) {
        if (item.id !== 0) {
            // if we select anything either than 'All', then deselect 'All' option.
            this.allOptionDisabled = false;
            const index = this.filteredByList.findIndex(v => v.id === 0);
            if (index !== -1) {
                this.filteredByList.splice(index, 1);
            }
            this.list[0].checked = false;
        } else {
            // user selected 'All', then deselect all other options
            this.allOptionDisabled = true;
            this.resetListCheckedStatus();
            this.addDefaultAllOption();
        }
    }

    setAllOptionWhenNoOptionIsSelected() {
        const optionSelected = this.list.filter(v => v.checked === true);
        if (optionSelected.length === 0) {
            this.allOptionDisabled = true;
            //clear, then  add it to list
            this.addDefaultAllOption();
        }
    }

    onApplyFilter() {
        this.triggerRequestListOnFilterValueChange();
        this.handleFilteredByDisplayName();
    }
    onResetFilter() {
        this.resetListCheckedStatus();
        this.addDefaultAllOption();

        this.handleFilteredByDisplayName();
        this.triggerRequestListOnFilterValueChange();
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['resetFilter'] && this.resetFilter === true) {
            this.resetListCheckedStatus();
            this.addDefaultAllOption();

            this.handleFilteredByDisplayName();
        }
    }
    getRequestListOnFilterValueChange() {
        let selectedFiltersIdList;
        selectedFiltersIdList = this.list.filter(v => v.checked === true).map(v => v.id);
        const filterDetails: { [key: string]: any } = {};
        const dynamicKey = this.filterKey;
        // Set the value for the dynamic key
        filterDetails[dynamicKey] = selectedFiltersIdList;
        this.OnSelectFilter.emit(filterDetails);
    }
    resetListCheckedStatus() {
        this.list.forEach((element, i) => {
            element.checked = i === 0;
        });
    }
    addDefaultAllOption() {
        this.filteredByList = [];
        const allOption = {
            name: this.translateService.instant('all'),
            id: 0,
            checked: true
        };
        this.filteredByList.push(allOption);
        this.list[0].checked = true;
    }
    triggerRequestListOnFilterValueChange() {
        this.getRequestListOnFilterValueChange();
    }
}
